import { render } from "./SavingsBalancesView.vue?vue&type=template&id=1d362e36&scoped=true"
import script from "./SavingsBalancesView.vue?vue&type=script&lang=js"
export * from "./SavingsBalancesView.vue?vue&type=script&lang=js"

import "./SavingsBalancesView.vue?vue&type=style&index=0&id=1d362e36&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d362e36"]])

export default __exports__